import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

// PrimeNG imports
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-sidenav',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    DividerModule,
    ButtonModule
  ],
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.css'
})
export class SidenavComponent {
  @Input() visible = false;

  constructor(private router: Router) {}

  logout(): void {
    // TODO: Add logout logic here (clear tokens, call auth service, etc.)
    console.log('Logout initiated');
    
    // Navigate to login page
    this.router.navigate(['/login']);
  }
}